import * as actionTypes from "../action-types";

const initialState = {
    reportsData: null,
    siteSettingsData: null,
    awardsData: [],
    mediaCoverageData: [],
    testimonialVideosData: [],
    blogsData: [],
    blogDetailData: null,
    communityMembersData: [],
};

const webReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_REPORTS:
            return { ...state, reportsData: payload };

        case actionTypes.SET_SITE_SETTINGS:
            return { ...state, siteSettingsData: payload };

        case actionTypes.SET_AWARDS:
            return { ...state, awardsData: payload };

        case actionTypes.SET_MEDIA_COVERAGE:
            return { ...state, mediaCoverageData: payload };

        case actionTypes.SET_TESTIMONIAL_VIDEOS:
            return { ...state, testimonialVideosData: payload };

        case actionTypes.SET_BLOGS:
            return { ...state, blogsData: payload };

        case actionTypes.SET_BLOG_BY_ID:
            return { ...state, blogDetailData: payload };

        case actionTypes.SET_COMMUNITY_MEMBERS:
            return { ...state, communityMembersData: payload };

        default:
            return state;
    }
};

export default webReducer;
